export default "__VITE_ASSET__e17e7360__"